export function replaceSitewithLocation(categories) {
  return categories?.map((category) =>
    category === "Site" ? "Location" : category
  );
}
export function sortCategories(categories) {
  return [...categories].sort((a, b) =>
    a === "Location" ? -1 : b === "Location" ? 1 : 0
  );
}

export function createEmptyFilters(categories) {
  return categories.reduce((acc, category) => {
    acc[category] = [];
    return acc;
  }, {});
}

export function prepareFilters(columns, pageIdentifier) {
  const filterColumns = columns.filter((c) => c.isFilter);
  const filterCategories = filterColumns.map((c) => c.dataIndex);
  const newCategories = replaceSitewithLocation(filterCategories);
  const sortedCategories = sortCategories(newCategories);

  const emptyFilters =
    pageIdentifier === "Alerts"
      ? createEmptyFilters(sortedCategories)
      : createEmptyFilters(filterCategories);

  return {
    filterCategories:
      pageIdentifier === "Alerts" ? sortedCategories : filterCategories,
    emptyFilters,
    filterColumns,
  };
}

export function mapData(data) {
  // Flatten array and remove duplicates
  const uniqueData = [...new Set(data.flatMap((item) => item))];
  // Map the data
  return uniqueData.map((value) => ({
    text: value,
    value: value,
    name: value,
  }));
}
